import { PMDetail } from '../models/pm-detail.model';


export class UpdatePMDetail {
    static readonly type = '[PMDetail] Update';

    constructor(public payload: PMDetail) {}
}

export class ClearPMDetail {
    static readonly type = '[PMDetail] Clear';

    constructor() {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/actions/pm-detail.action.ts